import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Text } = Typography;

const AuthProcessingOverlay = ({ visible, message = "Authenticating..." }) => {
  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: "rgba(246, 251, 249, 0.72)",
        backdropFilter: "blur(10px)",
      }}
    >
      <div
        style={{
          width: "min(360px, 100%)",
          borderRadius: 24,
          border: `1px solid ${OLIVEEB_COLORS.oliveebGreenSoft}`,
          background: `linear-gradient(145deg, ${OLIVEEB_COLORS.white} 0%, ${OLIVEEB_COLORS.greenSoft2} 100%)`,
          boxShadow: "0 24px 70px rgba(6, 105, 2, 0.20)",
          padding: "28px 24px",
          textAlign: "center",
        }}
      >
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 38,
                color: OLIVEEB_COLORS.oliveebGreen,
              }}
              spin
            />
          }
        />
        <div style={{ marginTop: 16 }}>
          <Text
            strong
            style={{
              color: OLIVEEB_COLORS.oliveebDarkGreen,
              fontSize: 18,
            }}
          >
            {message}
          </Text>
        </div>
        <Text style={{ color: OLIVEEB_COLORS.oliveebBlue, fontWeight: 700 }}>
          Setting up your Ovacus session
        </Text>
      </div>
    </div>
  );
};

export default AuthProcessingOverlay;
